import React, { useState, useEffect } from "react";
import { useTicketModuleListQuery } from "../../../../../services/ticketEasyService/ticketEasy-api";
import { TextField, Grid, MenuItem} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { setTicketConfigSelectedModule } from "../../../../../app/slices/TicketEasyModuleSlice";
import { TicketModule, createTicketModule } from "../../../../../services/ticketEasyService/model/ticketEasy/ticketModule/TicketModule";
import { resetTicketTypeConfig } from "../../../../../services/ticketEasyService/model/ticketEasy/ticketTypeConfig/TicketTypeConfigSlice";

function TicketModuleSelect() {
  const dispatch = useAppDispatch();
  const { data: ticketModuleList = [], error } = useTicketModuleListQuery();
  const selectedModule = useAppSelector(
    (state) => state.ticketEasyModule.TicketConfigSelectedModule
  );
  const [ticketModule, setTicketModule] = useState<TicketModule>(createTicketModule());

  useEffect(() => {
    const selectedTicketModule = ticketModuleList.find(
      (module) => module.name === selectedModule
    );
    if (selectedTicketModule) {
      setTicketModule(selectedTicketModule);
    }
  }, [selectedModule, ticketModuleList]);

  const handleModuleSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(resetTicketTypeConfig());
    const value = e.target.value;
      const selectedModule = ticketModuleList.find(
        (module) => module.name === value
      );
      if (selectedModule) {
        setTicketModule(selectedModule);
        dispatch(setTicketConfigSelectedModule(selectedModule.name));
      }
  };

  return (
    <React.Fragment>
      <Grid item xs={11}>
        <TextField
          select
          label="Module"
          name="module"
          value={ticketModule.name}
          onChange={handleModuleSelect}
          required
          fullWidth
        >
          {ticketModuleList.map((module: TicketModule) => (
            <MenuItem key={module.id} value={module.name}>
              {`${module.name} - ${module.description}`}
            </MenuItem>            
          ))}
        </TextField>
      </Grid>      
    </React.Fragment>
  );
}

export { TicketModuleSelect };
